// PublicSchedulePage Messages
export const INVALID_PARAMS_ERROR_MESSAGE = 'Invalid schedule parameters';
export const NO_GAMES_MESSAGE = 'No games in time period selected';
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const REFRESH_BUTTON_TEXT = 'Refresh';

// API Error Messages (Generic - used across all API calls)
export const API_ERROR_MESSAGES = {
  /**
   * Used when HTTP response is not OK (4xx, 5xx status codes)
   * Example: 404 Not Found, 500 Internal Server Error
   */
  FETCH_FAILED: 'Unable to load data',

  /**
   * Used when network request fails completely
   * Example: No internet connection, DNS failure, CORS error
   */
  NETWORK_ERROR: 'Network connection failed',

  /**
   * Used when request exceeds timeout limit
   * Example: Request takes longer than 10 seconds
   */
  TIMEOUT: 'Request timed out',

  /**
   * Used when response data format is invalid
   * Example: Expected JSON but got HTML, missing required fields
   */
  INVALID_RESPONSE: 'Invalid data format received',
} as const;
